import {RequestStatus, RequestStatusesEnum} from '@innowise-group/core';

const internationalizeStatus = (status: RequestStatus): string => {
  switch (status) {
    case RequestStatusesEnum.Approved:
      return 'approvedRequestsStatus';
    case RequestStatusesEnum.InClarification:
    case RequestStatusesEnum.Conflict:
      return 'inClarificationRequestsStatus';
    case RequestStatusesEnum.Rejected:
      return 'rejectedRequestsStatus';
    case RequestStatusesEnum.Delayed:
    case RequestStatusesEnum.Canceled:
      return 'canceledRequestsStatus';
  }
};
export default internationalizeStatus;
